module.exports = require('./helpers/bundle-url').getBundleURL('el9ZH') + "logo-dark.eefe0b7f.svg";